<template>
  <v-app>

    <v-main class="pa-0"  style="background-color: #F0ECE4;">
      <v-app-bar
          app
          absolute
          color="#F0ECE4"
          :elevation="2"
      >
        <v-row justify="center" align="center">
          <v-col cols="11" xl="9" lg="9">
            <router-link :to="{ name: 'lgportada'}">
              <v-img
                  alt="Lg Logo"

                  contain
                  min-width="100"
                  src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/logo.png"
                  width="100"
              /></router-link>
          </v-col>
        </v-row>


      </v-app-bar>

      <v-container fluid class="pt-6">
        <section>
          <v-row justify="center" align="center">
            <v-col cols="12" lg="3" xl="3" md="6" sm="6">

            <h1 >Crea tu Espacio</h1>
            </v-col>
          </v-row>
        </section>
        <section >
          <v-row justify="center" align="center">
            <v-col style="display:none;" cols="5" lg="1" xl="1" md="2" sm="6">
              <router-link :to="{ name: 'lgportada'}">    <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/volver.png" /></router-link>
            </v-col>
            <v-col cols="8" lg="2" xl="2" md="4" sm="6">
              <center>
                <v-menu
                    open-on-hover
                    offset-y
                >
                  <template v-slot:activator="{ attrs, on }">

                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="hidden-xs-only hidden-sm-only"
                        text
                        style="color: #A50035;  font-size:xx-large; font-family: 'LGSmartUI';letter-spacing: normal !important; font-weight: bold; text-transform: none; text-decoration: underline;"
                    >Cocina/Lavandería</v-btn>
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="hidden-xl-only hidden-lg-only hidden-md-only"
                        text
                        style="color: #A50035;  font-size:xx-large; font-family: 'LGSmartUI';letter-spacing: normal !important; font-weight: bold; text-transform: none; text-decoration: underline;"
                    >Cocina <br/> Lavandería</v-btn>
                  </template>
                  <v-list>
                    <v-list-item style="color: #A50035;  font-size:medium; font-family: 'LGSmartUI'; letter-spacing: normal !important; text-transform: none;" @click="eligerefri" >Refrigeradoras</v-list-item>
                    <v-list-item style="color: #A50035;  font-size:medium; font-family: 'LGSmartUI'; letter-spacing: normal !important; text-transform: none;" @click="eligelavadora">Lavadoras</v-list-item>
                  </v-list>
                </v-menu>
              </center>
            </v-col>
            <v-col cols="8" lg="2" xl="2" md="3" sm="6">
              <center><router-link :to="{ name: 'lgdormitorio'}" style="color: #848381; letter-spacing: normal !important; text-decoration: none; font-size:30px; font-weight: bold;">Dormitorio</router-link></center>
            </v-col>
            <v-col cols="8" lg="2" xl="2" md="3" sm="6">
              <center>   <router-link :to="{ name: 'lgsala'}" style="color: #848381; text-decoration: none; letter-spacing: normal !important; font-size:30px; font-weight: bold; "> Sala</router-link></center>
            </v-col>
          </v-row>
          <v-row  justify="center" align="center">
            <v-col  cols="12" sm="12" md="8" lg="9" style="background-color: transparent !important;">

              <v-row justify="center" align="center" >

                <v-col cols="11">
                  <v-row>
                    <v-col cols="4">
                      <v-row justify="start" align="center">
                        <v-col xl="3" lg="5" md="5"  style="font-family: 'LGSmartUI' !important;">
                          Menos tecnológico                      </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4" style=" color: #A50035; font-family: 'LGSmartUI' !important;">
                      <center style=" color: #A50035; font-family: 'LGSmartUI' !important;">Gamma Media</center>
                    </v-col>
                    <v-col cols="4"  style="text-align: end;">
                      <v-row justify="end" align="center">
                        <v-col xl="3" lg="5" md="5" style="font-family: 'LGSmartUI' !important;">
                          Más tecnológico
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="11">
                  <v-slider @change="cmbprodgamma" color="#DDD9D0" :thumb-size="72" thumb-color="#A50035" track-color="#DDD9D0" v-model="gamma" :min="minimo" :max="maximo" :step="1" ></v-slider>
                </v-col>
              </v-row>
              <v-row align="stretch" justify="center" class="hidden-sm-only hidden-xs-only">
                <v-col col="1" lg="1" md="1" class="d-flex flex-column">
                  <v-row align="end" justify="end">
                    <v-col style="text-align: end; color: #A50035; font-family: 'LGSmartUI' !important;">
                      Tamaño Grande
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>  <v-slider @change="cmbprodtamanio" color="#DDD9D0" :thumb-size="36" thumb-color="#A50035" track-color="#DDD9D0" vertical height="100%" style="height: 500px; color: #A50035;" v-model="tamanio" :min="minimo" :max="maximo" :step="1" label="Tamaño Mediano"></v-slider>
                    </v-col>
                  </v-row>  <v-row align="start" justify="start">
                  <v-col style="text-align: end; color: #A50035; font-family: 'LGSmartUI' !important;">
                    Tamaño Pequeño
                  </v-col>
                </v-row>
                </v-col>
                <v-col cols="11" lg="11" md="11" class="d-flex flex-column">
                  <div  class="background-image-container" @click="handleBackgroundClick">

                    <img ref="baseImage" width="100%" :src="backgroundImageUrl" />
                    <overlay-image
                        v-for="(overlay, index) in overlays"
                        :key="index"
                        :overlay="overlay"
                        :overlay-index="index"
                        :background-image-size="backgroundImageSize"
                        @overlay-moved="handleOverlayMoved"
                        @overlay-contextmenu="handleOverlayContextMenu"
                        @contextproduct="handleOverlayContextProducto"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row align="center" justify="center" class="hidden-xl-only hidden-lg-only hidden-md-only">
                <v-col col="11"  >

                  <v-row>
                    <v-col cols="12" class="productoreg">
                      <center style=" color: #A50035; font-family: 'LGSmartUI' !important;">Tamaño</center>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="4">
                          <v-row justify="start" align="center">
                            <v-col xl="3" lg="5" md="5"  style="font-family: 'LGSmartUI' !important;">
                              Tamaño Pequeño                      </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" style=" color: #A50035; font-family: 'LGSmartUI' !important;">
                          <center style=" color: #A50035; font-family: 'LGSmartUI' !important;">Mediano</center>
                        </v-col>
                        <v-col cols="4"  style="text-align: end;">
                          <v-row justify="end" align="center">
                            <v-col xl="3" lg="5" md="5" style="text-align:end;font-family: 'LGSmartUI' !important;">
                              Tamaño Grande
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">  <v-slider @change="cmbprodtamanio" color="#DDD9D0" :thumb-size="36" thumb-color="#A50035" track-color="#DDD9D0"  height="100%" style=" color: #A50035;" v-model="tamanio" :min="minimo" :max="maximo" :step="1" ></v-slider>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="11" lg="11" md="11" >
                  <div  class="background-image-container" @click="handleBackgroundClick">

                    <img ref="baseImageMob" width="100%" :src="backgroundImageUrl" />
                    <overlay-image
                        v-for="(overlay, index) in overlays"
                        :key="index"
                        :overlay="overlay"
                        :overlay-index="index"
                        :background-image-size="backgroundImageSize"
                        @overlay-moved="handleOverlayMoved"
                        @overlay-contextmenu="handleOverlayContextMenu"
                        @contextproduct="handleOverlayContextProducto"
                    />
                  </div>
                </v-col>


              </v-row>

            </v-col>
            <v-col  cols="12" sm="12" md="6" lg="2" >
              <v-row>
                <v-col>
                  <v-img height="200px" contain :src="producto.image" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h2 class="productoreg lgbold" >Nombre:</h2>
                </v-col>

                <v-col style="color:#8D8C89; font-family: 'LGSmartUI' !important;" class="lgnormal">
                  {{producto.name}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2 class="productoreg lgbold">Modelo:</h2>
                </v-col>

                <v-col style="color:#8D8C89; font-family: 'LGSmartUI' !important;" class="lgnormal">
                  {{producto.modelo}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2 class="productoreg lgbold">Precio: </h2>
                </v-col>
                <v-col style="color:#8D8C89; font-family: 'LGSmartUI' !important;" class="lgnormal">
                  <span style="text-decoration:line-through;" class="lgnormal"> {{producto.precio}}</span> {{producto.preciodscto}}
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <h2 class="productoreg lgbold"> Descripción: </h2>
                </v-col>

              </v-row>
              <v-row>
                <v-col style="color:#8D8C89; font-family: 'LGSmartUI' !important;" class="lgnormal">
                  {{producto.descripcion}}
                </v-col>

              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="10">
                  <img alt="boton"
                       src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/btncupon.png"
                       style="cursor: pointer;"
                       @click="scrollToSection"
                  />
                </v-col>

              </v-row>

            </v-col>
          </v-row>


          <v-row style="display: none;"  justify="center" align="center">
            <v-col cols="12" sm="12" md="11" lg="11">
              <v-card class="custom-rounded-card">
                <v-card-text>
                  <carousel-3d :controls-visible="true" :clickable="false" :height="360">
                    <slide
                        v-for="(prod, index) in productosfilt"
                        :key="index"
                        :index="index"

                    >
                      <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                        <h3 style="color:#000000 !important;text-align: center;">{{prod.modelo}}</h3>
                        <img :data-index="index" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }" :src="prod.image"  @click="cambiaprod(prod)">
                      </template>
                    </slide>
                  </carousel-3d>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row justify="center" align="center"  >
            <v-col cols="12" sm="12" md="11" lg="11">
              <v-card class="custom-rounded-card"><v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                  <v-row  ref="targetSection" justify="center" align="center" class=" ma-0 ma-lg-12 ma-xl-12 ma-md-10" >
                    <v-col cols="12" style="color: #8D8C89; font-size: larger;">
                      <h2 style="text-align: center;color:#A50035;font-family: 'LGSmartUI' !important;">CON TUS COMPRAS EN LG.COM PARTICIPA DEL SORTEO DE ESTOS PREMIOS</h2><br/>
                      <p style="font-family: 'LGSmartUI' !important;">Premio 1: Decoración del espacio de tu casa valorizado en S/. 10,000 con la asesoría de Yesenia Schulz</p>
                      <p style="font-family: 'LGSmartUI' !important;">Premio 2: Mesa de centro de Bo Concept Store</p>
                      <p style="font-family: 'LGSmartUI' !important;">Completa tus datos, usa el cupón de descuento y listo, ya estas participando</p>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="ma-0  pa-1">
                      <v-text-field outlined  v-bind:style="styleComponent" v-model="editedItem.nombre" :label="$t('formularios.nombres')" :rules="[rules.required]"> </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="ma-0 pa-1">
                      <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.apellidoPaterno" :label="$t('formularios.ApPaterno')" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="ma-0 pa-1">
                      <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.dni"  label="DNI / Carnet de Extranjeria" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"  class="ma-0 pa-1">
                      <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.email" label="Correo" :rules="emailRules" ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"  class="ma-0 pa-1">

                      <v-text-field class="ma-0" outlined v-bind:style="styleComponent" v-model="editedItem.telefono" label="Celular" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-row>

                        <v-col  cols="2" sm="2" md="2" class="mt-0 pa-1">

                          <v-checkbox
                              v-model="editedItem.aceptoCondicion"
                              :rules="[v => !!v || 'Debes aceptar para continuar']"

                              required
                              style="color: #1E3D90 !important;"
                              color="#1E3D90"
                              class="ma-0"
                          ></v-checkbox> </v-col>
                        <v-col  cols="9" sm="9" md="9" class="mt-0 pa-1" style="font-family: 'LGSmartUI' !important;"> Acepta los <a href="https://www.lg.com/pe/tycdecoratuespacio" target="_blank">Términos y Condiciones</a>
                        </v-col></v-row>

                    </v-col>


                    <v-col cols="12" sm="6" md="6" lg="6">
                      <v-alert
                          :value="alerterror"
                          color="red"
                          dark
                          dismissible
                          border="top"
                          transition="scale-transition"
                      >
                        {{error}}
                      </v-alert>
                      <center>  <v-btn color="#A50035" style="color: #FFFFFF; padding: 25px !important; height: 50px !important; border-radius: 15px !important; font-size: 25px;"  @click="saveImage">PARTICIPAR</v-btn>
                      </center>   </v-col>
                  </v-row>
                </v-form>
              </v-card-text></v-card>

              <v-dialog  v-model="terminos" width="50%" >
                <v-card color="#F0ECE4">
                  <v-card-text class="pa-6">
                    <v-row>
                      <v-col>
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/terminostitulo.png"></v-img>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/terminosprimero.png"></v-img>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/terminoscodigos.png"></v-img>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/terminosdos.png"></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col cols="3">
                        <v-img src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/lifesgood.png"></v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <v-dialog  :scrollable="false" v-model="diseniodialog" content-class="cdises" width="70%" >
                <center><v-row justify="center" align="center" @click="diseniodialog = false">
                  <v-col cols="8" @click="diseniodialog = false">
                    <v-img width="100%" src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/popup.png" @click="diseniodialog = false" /></v-col></v-row></center>
              </v-dialog>
            </v-col>
          </v-row>
        </section>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import OverlayImage from "@/components/componente/OverlayImage.vue";
import { Carousel3d, Slide } from 'vue-carousel-3d';
import lgproductos from "@/assets/json/lgproductos.json";

// optional style for arrows & dots
export default {
  name: "lgcocina",
  components: {OverlayImage, Carousel3d,
    Slide},
  title: "LG",
  data () {
    return {
      selectedOverlayIndex: null,
      currentIndex: 0,
      itemsToShow: 4,
      categoria:"cocina",
      valida:false,
      valid:true,
      tiposdoc: [{id:1,tipoDocumento:"DNI",paisId:173}],
      maximo:9,
      minimo:1,
      terminos:false,
      imagendiseniada:'',
      rules: {
        required: value => !!value || 'Requerido.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        minimo: value => value.length >= 3 || 'Minimo 3 caracteres',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Mail invalido.'
        },
      },
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      alerterror:false,
      error:'',
      gamma:8,
      tamanio:7,
      prodc:'',
      backgroundImageSize: { width: 0, height: 0 },
      producto:{
        name:'',
        image:'',
        width:'',
        modelo:'',
        descripcion:'',
        precio:''
      },
    instrucciones:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/instrucciones.png',
      editedItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
        telefono:'',
        direccion:'',
        sexo:{},
        tipoDocumento:{},
        ref1:'',
        ref2:'',
      },
      diseniodialog:false,
      categorias:[{nombre:"Sala",codigo:"sala"},{nombre:"Cocina",codigo:"cocina"},{nombre:"Dormitorio",codigo:"cuarto"}],
      backgroundImageUrl:'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/ambiente1.jpg',
      ambientesfiltr:[],
      ambiente:{nombre:"cocina1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1v.png",categoria:"cocina",ancho:"600",anchoMob:"400"},
      ambientes:[{nombre:"sala1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala1v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
        {nombre:"sala2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/sala2v.png",categoria:"sala",ancho:"450",anchoMob:"250"},
        {nombre:"cocina1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1.png",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1v.png",categoria:"cocina",ancho:"600",anchoMob:"400"},
        {nombre:"cocina2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina2v.png",categoria:"cocina",ancho:"450",anchoMob:"250"},
        {nombre:"cuarto1",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto1v.png",categoria:"cuarto",ancho:"450",anchoMob:"250"},
        {nombre:"cuarto2",url:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto2.jpg",urlMob:"https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cuarto2v.png",categoria:"cuarto",ancho:"450",anchoMob:"250"}],
      alertnuevo: false,
      overlays:[],
      tagevento:'',
      productos:[],
      stylePagina: {
        fontColor:'black',
        fontFamily: 'LGSmartUI',
        color: '#1E3D90',
        backgroundColor:'#FFFFFF'
      },
      styleComponent:{
        color:'#1E3D90',
        backgroundColor:'#FFFFFF'
      },
      styleCabecera:{
        color:'#1E3D90',
        backgroundColor:'#FFFFFF'
      },
      styleForm:{
        color:'#000000',
        marginTop:'0px !important',
        fontFamily: 'LGSmartUI'
      },
      btnPag: {
        backgroundColor: '#1E3D90',
        color:'white'
      },
    }
  },
  created () {
    this.$vuetify.theme.dark = false
  },

  watch: {
    date () {
      this.editedItem.fechaNacimiento = this.formatDatee(this.date)
    }
  },
  mounted () {
    this.tagevento =  'lgexperiencia';
    this.getImageSize();
    this.productos = lgproductos;
    this.escogecat();
    if(!this.$device.mobile){
      this.backgroundImageUrl = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1.png'
      this.instrucciones = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/instrucciones.png'
    }else{
      this.backgroundImageUrl = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/ambientes/cocina1v.png'
      this.instrucciones = 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/lg/instruccionesM.png'
    }
  },
  methods: {
    eligerefri(){
      this.minimo = 1;
      this.maximo = 9;
      this.prodc = "Refrigeradora";
      this.gamma = 8
      this.tamanio = 7
      this.cmbprod()
    },
    scrollToSection() {
      this.$nextTick(() => {
        const targetElement = this.$refs.targetSection;

        if (targetElement && targetElement.$el) {
          const targetPosition = targetElement.$el.offsetTop;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    },
    eligelavadora(){
      this.minimo = 1;
      this.maximo = 7;
      this.gamma= 7
      this.tamanio = 7
      this.prodc = "Lavadora";
      this.cmbprod()

    },
    cmbprod(){
      let itm = this.productos.find(item=> item.categoria=== this.categoria && item.producto === this.prodc && item.tamanio === this.tamanio && item.gamma === this.gamma )
      console.log(itm)
      if (itm!==undefined){
        this.eligeprod(itm)
      }
    },
    cmbprodgamma(){
      let itm = this.productos.find(item=> item.categoria=== this.categoria && item.producto === this.prodc && item.gamma === this.gamma )
      console.log(itm)
      if (itm!==undefined){
        this.tamanio = itm.tamanio
        this.eligeprod(itm)
      }
    },
    cmbprodtamanio(){
      let itm = this.productos.find(item=> item.categoria=== this.categoria && item.producto === this.prodc && item.tamanio === this.tamanio  )
      console.log(itm)
      if (itm!==undefined){
        this.gamma = itm.gamma
        this.eligeprod(itm)
      }
    },
    eligeprod(item){
      var ancho = 0;
      var anchoimg = 0;
      var altoimg = 0;
      var newX = 0;
      var newY = 0;
      var imagen;
      if(this.$device.mobile){
        ancho = this.ambiente.anchoMob
        imagen = this.$refs.baseImageMob;
      }else{
        ancho = this.ambiente.ancho
        imagen = this.$refs.baseImage;
      }
      anchoimg = imagen.offsetWidth;
      altoimg = imagen.offsetHeight;

      let newWidth = Number(item.width) * anchoimg / Number(ancho)
      if(this.$device.mobile){
        newX = item.positionM.x * anchoimg
        newY = item.positionM.y * altoimg
      }else{

        newX = item.position.x * anchoimg
        newY = item.position.y * altoimg
      }
      let obj = {
        imageUrl: item.image,
        width: newWidth+"px",
        producto: item.producto,
        position: { x: newX, y: newY },
        id: item.id
      }
      const doesExistPrd = this.overlays.some(obj => obj.producto === item.producto);
      console.log(doesExistPrd)
      if (!doesExistPrd){
        console.log('No Existe prod')

        const doesExist = this.overlays.some(obj => obj.imageUrl === item.image);
        console.log(doesExist)
        if (!doesExist) {
          console.log(obj)
          this.overlays.push(obj)
        }
      }else{
        this.overlays = this.overlays.filter(function(elemento) {
          console.log(elemento)
          return elemento.producto !== item.producto;
        })
        this.overlays.push(obj)

      }
      console.log(this.overlays )
      this.producto = item
    },
    async loadImageFromS3(imageUrl) {
      try {
        const response = await axios.get(imageUrl+'?not-from-cache-please`', {
          headers: { "Cache-Control": "no-cache" },
          responseType: 'blob'
        });
        return response.data;
      } catch (error) {
        console.error('Error al cargar la imagen desde S3:', error);
        return null;
      }
    },
    handleOverlayContextMenu(index) {
      // Eliminar el elemento del array overlays en función del índice
      this.overlays.splice(index, 1);
    },
    verterminos(){
      this.terminos = true;
    },
    calculateNewHeight(originalWidth, originalHeight, newWidth) {
      // Asegurarse de que los valores sean números válidos
      const originalWidth2 = parseFloat(originalWidth) || 1;
      const  originalHeight2 = parseFloat(originalHeight) || 1;
      const   newWidth2 = parseFloat(newWidth) || 1;

      // Calcular el nuevo alto manteniendo las mismas proporciones (aspect ratio)
      const newHeight = (newWidth2 / originalWidth2) * originalHeight2;
      return newHeight;
    },
    async saveImage() {
      this.overlay = true
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      var imgr = '';
      if(this.$device.mobile){
        canvas.width  = this.$refs.baseImageMob.width;
        canvas.height = this.$refs.baseImageMob.height;
        imgr = this.$refs.baseImageMob.src
      }else{
        canvas.width = this.$refs.baseImage.width;
        canvas.height = this.$refs.baseImage.height;
        imgr = this.$refs.baseImage.src
      }
      try {


        const imageBlob = await this.loadImageFromS3(imgr);

        if(imageBlob){
          // Configura el tamaño del canvas según el tamaño de las imágenes
          const img = new Image();
          img.src = URL.createObjectURL(imageBlob);

          await new Promise((resolve) => {
            img.onload = resolve;
          });

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);


          await Promise.all(
              this.overlays.map(async (overlayImageUrl) => {
                const overlayImageBlob = await this.loadImageFromS3(overlayImageUrl.imageUrl);

                if (overlayImageBlob) {
                  const imgR = new Image();
                  imgR.src = URL.createObjectURL(overlayImageBlob);

                  await new Promise((resolve) => {
                    imgR.onload = resolve;
                  });
                  const newwidth = overlayImageUrl.width.slice(0, -2);

                  ctx.drawImage(
                      imgR,
                      overlayImageUrl.position.x,
                      overlayImageUrl.position.y,
                      newwidth,
                      this.calculateNewHeight(imgR.width, imgR.height, newwidth)
                  );
                }
              })
          );

          // Obtén la imagen combinada como una URL de datos
          const combinedImageUrl = canvas.toDataURL('image/jpeg');
          await this.grabarexp(combinedImageUrl);


          //   Crea un enlace para descargar la imagen
          //  //  const link = document.createElement('a');
          //  link.href = combinedImageUrl;
          //   link.download = 'imagen_combinada.png';

          // Simula un clic en el enlace para iniciar la descarga
          //  link.click();

        }
      } catch (error) {
        console.error('Error al procesar la imagen:', error);
      }

    },
    async resizeImage(blob, maxSizeInBytes) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Redimensionar la imagen manteniendo la proporción original
          const maxWidth = 800; // Puedes ajustar el ancho máximo según tus necesidades
          const maxHeight = 800; // Puedes ajustar la altura máxima según tus necesidades

          let newWidth = img.width;
          let newHeight = img.height;

          if (newWidth > maxWidth) {
            newHeight *= maxWidth / newWidth;
            newWidth = maxWidth;
          }

          if (newHeight > maxHeight) {
            newWidth *= maxHeight / newHeight;
            newHeight = maxHeight;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          // Obtener el Blob de la imagen redimensionada
          canvas.toBlob((resizedBlob) => {
            if (resizedBlob) {
              if (resizedBlob.size <= maxSizeInBytes) {
                resolve(resizedBlob);
              } else {
                reject(new Error(`La imagen redimensionada sigue siendo demasiado grande.`));
              }
            } else {
              reject(new Error('Error al crear el Blob de la imagen redimensionada.'));
            }
          }, 'image/jpeg'); // Puedes ajustar el formato de la imagen según tus preferencias
        };
        img.onerror = () => {
          reject(new Error('Error al cargar la imagen.'));
        };
      });
    },
    async getImageBlob(imageUrl) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          } else {
            reject(new Error(`Error al obtener la imagen: ${xhr.status}`));
          }
        };
        xhr.onerror = () => {
          reject(new Error('Error al obtener la imagen.'));
        };
        xhr.open('GET', imageUrl);
        xhr.send();
      });
    },

    async grabarexp(combinedImageUrl){
      this.overlay = true
      const originalBlob = await this.getImageBlob(combinedImageUrl);
      const maxSizeInBytes = 2 * 1024 * 1024; // 2 megabytes
      if (originalBlob.size > maxSizeInBytes) {
        const resizedBlob = await this.resizeImage(originalBlob, maxSizeInBytes);
        if (resizedBlob) {
          var bodyFormData = new FormData();
          this.overlay = true;
          this.editedItem.fechaNacimiento = '01-01-1992'

          this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 1)
          let eevve = 32
          bodyFormData.append("estadoEventoId",eevve)
          bodyFormData.append("persona",JSON.stringify(this.editedItem))
          bodyFormData.append("tagevento",this.tagevento)
          bodyFormData.append("file",resizedBlob)
          this.rest = true
          axios
              .post('tickets/grabar/formulario/lg',bodyFormData,{
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                  'Content-Type':'multipart/form-data'
                }
              })
              .then(response => {
                let ticketMin = response.data;
                this.diseniodialog= true
                this.imagendiseniada = ticketMin.depositoTicket.voucher
                this.editedItem = this.defaultdItem
                this.alertnuevo = true
                this.rest = false
                this.overlay = false

              })
              .catch((error)  => {
                console.error(error);
                this.overlay = false
                this.diseniodialog= true
              });

        } else {
          console.error('Error al redimensionar la imagen.');
          return;
        }
      }else{
        var bodyFormData2 = new FormData();
        this.overlay = true;
        this.editedItem.fechaNacimiento = '01-01-1992'

        this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 1)
        let eevve = 32
        bodyFormData2.append("estadoEventoId",eevve)
        bodyFormData2.append("persona",JSON.stringify(this.editedItem))
        bodyFormData2.append("tagevento",this.tagevento)
        bodyFormData2.append("file",originalBlob)
        this.rest = true
        axios
            .post('tickets/grabar/formulario/lg',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
                'Content-Type':'multipart/form-data'
              }
            })
            .then(response => {
              let ticketMin = response.data;
              console.log(ticketMin)
              this.editedItem = this.defaultdItem
              this.alertnuevo = true
              this.rest = false
              this.overlay = false
              this.valid = true
              this.$refs.form.resetValidation()
            })
            .catch((error)  => {
              console.error(error);
              this.overlay = false
            });
      }
    },
    handleOverlayContextProducto(model) {
      this.producto = this.productos.find(x=>x.id === model );
    },
    cambiaprod(item){
      let ancho = 0;
      if(this.$device.mobile){
        ancho = this.ambiente.anchoMob
      }else{
        ancho = this.ambiente.ancho
      }
      const imagen = this.$refs.baseImage;
      console.log(ancho)
      // Capturamos el ancho de la imagen una vez que se ha cargado
      const anchoimg = imagen.offsetWidth;
      console.log(anchoimg)
      /*  let newWidth = Number(item.width) * anchoimg / Number(ancho)
        let obj = {
          imageUrl: item.image,
          width: newWidth+"px",
          position: { x: item.position.x, y: item.position.y }
        }
        const doesExist = this.overlays.some(obj => obj.imageUrl === item.image);
        if (!doesExist) {
          this.overlays.push(obj)
        } */
      this.producto = item
    },
    escogecat(){
      this.ambientesfiltr = this.ambientes.filter(item=> item.categoria === this.categoria)
    },
    escogeamb(){
      if(this.$device.mobile){
        this.backgroundImageUrl = this.ambiente.urlMob

      }else{
        this.backgroundImageUrl = this.ambiente.url

      }
    },
    getImageSize() {
      const img = new Image();
      img.src = this.backgroundImageUrl;
      img.onload = () => {
        this.backgroundImageSize = {
          width: img.width,
          height: img.height
        };
      };
    },
    handleBackgroundClick() {
      if (this.selectedOverlayIndex !== null) {
        // Clear selection when clicking on the background
        this.selectedOverlayIndex = null;
      }    },
    handleOverlayMoved(overlayIndex, newPosition) {
      // Update the position of the overlay in the overlays array

      console.log('llega el movimiento')
      this.overlays[overlayIndex].position = newPosition;

    }

  },
  computed: {
    carouselStyles() {
      const translateX = -this.currentIndex * (100 / this.itemsToShow);
      return `transform: translateX(${translateX}%)`;
    },
    productosfilt() {
      let productosfilt =  [...this.productos];
      productosfilt = productosfilt.filter(item => item.categoria === this.categoria)
/*
      if(this.gamma){
        productosfilt = productosfilt.filter(item=> item.gamma === this.gamma)
      }
      if(this.tamanio){
        productosfilt = productosfilt.filter(item=> item.tamanio === this.tamanio)
      } */
      return productosfilt;
    }

  }
}
</script>

<style >
.grecaptcha-badge{
  display: none;
}
body{
  background: #B69C96;
  overflow-y: hidden;
  overflow-x: hidden;
}
.background-image-container {
  position: relative;
}
.custom-rounded-card {
  border-radius: 35px !important; /* Ajusta el valor para cambiar la cantidad de redondeo */
}
.carousel-3d-slide img{
  width: auto !important;
  height: 100% !important;
}

.v-input .v-label{
  color:#A50035 !important;
}
.carousel-3d-slide{
  border: none !important;
  background-color: #FFFFFF !important;
  text-align: center !important;
}
.cdises{
  overflow: hidden !important;
  overflow-y: hidden !important;
  box-shadow: none !important;
}

.v-slider--vertical{
  min-height: 450px !important;
}

.v-slider--vertical .v-slider__track-container{
  height: 100% !important;
  width: 10px !important;
}

.v-slider__track-container{
  height: 10px !important;
}

.productoreg{
  color:#A50035;
  font-family: 'LGSmartUI' !important;
  font-size: medium;
  font-weight: bold;
}
.v-label{
  color:#A50035 !important;
  font-family: 'LGSmartUI' !important;
  font-size: medium !important;
}
.lgbold{
  font-family: 'LGSmartUI' !important;font-weight: bold !important; font-style: normal !important;
}
.lgnormal{
  font-family: 'LGSmartUI' !important;font-weight: normal !important; font-style: normal !important;
}
</style>